// Browser push notifications (local, no FCM needed for basic use)
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../context/AuthContext';

const LAST_SEEN_KEY = 'gsk_last_notif_check';

export function useBrowserPush() {
  const [permission, setPermission] = useState(
    typeof Notification !== 'undefined' ? Notification.permission : 'default'
  );

  const request = useCallback(async () => {
    if (typeof Notification === 'undefined') return 'unsupported';
    const p = await Notification.requestPermission();
    setPermission(p);
    if (p === 'granted') {
      new Notification('Gurusevakendra', {
        body: 'ଆପଣଙ୍କୁ ନୂଆ update ପାଇଁ notification ମିଳିବ 🎉',
        icon: '/favicon.ico',
      });
    }
    return p;
  }, []);

  const show = useCallback((title, body) => {
    if (permission === 'granted') {
      new Notification(title, { body, icon: '/favicon.ico', badge: '/favicon.ico' });
    }
  }, [permission]);

  return { permission, request, show };
}

// Poll backend for new notifications and show browser toast if new ones arrive
export function useNotificationPoller(enabled = true) {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    let alive = true;

    const check = async () => {
      try {
        const res = await axios.get(`${API}/notifications`, { withCredentials: true });
        if (!alive) return;
        const arr = res.data || [];
        setItems(arr);
        const lastSeen = parseInt(localStorage.getItem(LAST_SEEN_KEY) || '0', 10);
        const newer = arr.filter((n) => new Date(n.created_at).getTime() > lastSeen);
        setUnread(newer.length);

        if (newer.length > 0 && typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          newer.slice(0, 2).forEach((n) => {
            try { new Notification(n.title, { body: n.body, icon: '/favicon.ico' }); } catch (e) { console.warn('notification failed', e); }
          });
        }
      } catch (e) { console.warn('push poll failed', e); }
    };

    check();
    const t = setInterval(check, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [enabled]);

  const markSeen = useCallback(() => {
    localStorage.setItem(LAST_SEEN_KEY, String(Date.now()));
    setUnread(0);
  }, []);

  return { items, unread, markSeen };
}
